import { inject } from "@angular/core";
import { AuthTokenStore } from "../../shared/stores/auth-token-store";
import { sessionAlreadyActiveToken } from "./auth-constants";
import { AuthService } from "./auth-service";
import { TokenRefreshService } from "./token-refresh.service";
import { CsrfService } from "./csrf-service";
import { Router } from "@angular/router";
import { firstValueFrom } from "rxjs";

export function tokenInitializer() {
  return async () => {
    const authTokenStore = inject(AuthTokenStore);
    const authService = inject(AuthService);
    const tokenRefreshService = inject(TokenRefreshService);
    const router = inject(Router);
    const csrfService = inject(CsrfService);
    try {
      const hash = window.location.hash.substring(1);
      const param = new URLSearchParams(hash);
      const errorFromURL = param.get("error");

      if (errorFromURL) {
        // Store error in sessionStorage temporarily - will be cleared after being shown once
        sessionStorage.setItem("userRoleError", errorFromURL);
        window.history.replaceState({}, document.title, window.location.pathname);
        await router.navigate(["/login"]);
        return;
      }
      const existingToken = authTokenStore.getAccessToken();
      if (existingToken) {
        await csrfService.loadCsrfToken();
        tokenRefreshService.startRefreshTimer();
        return;
      }
      const userState = localStorage.getItem("userState");
      if (!userState) {
        return;
      }
      const storedData = JSON.parse(userState);
      const response = await firstValueFrom(authService.getCustomToken(storedData));
      const token = response.headers.get("x-msu-authsession");
      if (!token) {
        console.error("Token missing in response header");
        await router.navigate(["/login"]);
        return;
      }
      if (token === sessionAlreadyActiveToken) {
        authService.logout();
        return;
      }

     authTokenStore.setAccessToken(token);
     localStorage.removeItem('userState');
      await csrfService.loadCsrfToken();
      tokenRefreshService.startRefreshTimer();
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (error) {
      console.error("Token initialized failed", error);
      authService.logout();
    }
  };
}
